'use strict';
/* eslint no-sync: 0 */

import angular from 'angular';

export class NavbarComponent {
  isCollapsed = true;

  constructor(Auth, $state, MENU_CONFIG, PUBLIC_MENU_CONFIG, Config, User, $http) {
    'ngInject';

    this.isLoggedIn = Auth.isLoggedInSync;
    this.isAdmin = Auth.isAdminSync;
    this.isSuperAdmin = Auth.isSuperAdminSync;
    this.Config = Config;

    this.User = User;
    this.$http = $http;
    this.hasRole = Auth.hasRoleSync;

    this.getCurrentUser = Auth.getCurrentUserSync;
    this.$state = $state;

    this.searchterm = null;
    this.searchSubmitted = false;

    this.menu = MENU_CONFIG.data || [];
    this.publicMenu = PUBLIC_MENU_CONFIG.data || [];

    this.showUserMenuLabel = Config.getModuleConfig(Config.Modules.General).showUserMenuLabel();
    this.userMenuLabel = Config.getModuleConfig(Config.Modules.General).getUserMenuLabel();
    this.defaultMenuPermission = Config.getPlatformConfig().getMenuDefaultPermission();
    this.navbarStyle = Config.getPlatformConfig().getNavbarStyle();
    this.navbarContainer = Config.getPlatformConfig().getNavbarContainer();
    this.navbarInterceptor = Config.getPlatformConfig().getNavbarInterceptor();

    this.hasPaymentsActivated = Config.isModuleEnabled(Config.Modules.Payment);

    this.homeImage = Config.getPlatformConfig().getHomeImage();
    this.homeText = Config.getPlatformConfig().getHomeText();
    this.accountAsMenu = Config.getPlatformConfig().getAccountAsMenu();

    this.signUpDeactivated = Config.getModuleConfig(Config.Modules.SignUp).getDeactivated();
    this.loginDeactivated = Config.getModuleConfig(Config.Modules.SignUp).getLoginDeactivated();
  }

  $doCheck() {
    this.isDigitalSignage = this.$state.current.name == 'digital-signage';
  }

  getPathHome() {
    return (this.isLoggedIn()) ? "/home" : "/";
  }

  hasPermission(menuEntry) {
    let allowedRoles = [];

    if (angular.isArray(menuEntry.permission)) {
      allowedRoles = menuEntry.permission;
    } else if (typeof menuEntry.permission == 'string') {
      allowedRoles = [menuEntry.permission];
    } else if (this.defaultMenuPermission) {
      allowedRoles = [this.defaultMenuPermission];
    } else {
      return false;
    }

    for (let role of allowedRoles) {
      if (this.hasRole(role)) {
        return true;
      }
    }

    return false;
  }

  search(form) {
    this.searchSubmitted = true;

    if(form.$valid) {
      this.searchSubmitted = false;
      this.$state.go('search-result',{searchterm: this.searchterm});
    }
  }

  invokeFunction(fnName) {
    switch (fnName) {
      case 'groupEmails':
        this.User.query(users => {
          let emails = users.filter(user => user.active && user.role.includes("member"))
            .map(user => user.email)
            .join('; ');

          prompt("All Group Emails of Active Members", emails);
        });
        break;
      case 'allEmails':

        let onComplete = _ => {
          prompt("All Emails of Active Members of All Groups", [...new Set(this.emails)].join('; '));
        };

        this.done = 0;
        this.groups = this.Config.getModuleConfig(this.Config.Modules.General).getGroups();
        this.maxDone = this.groups.length;

        this.emails = [];

        this.groups.forEach(group => {

          this.$http({
            method: 'GET',
            url: group.url + '/api/users'
          }).then((response) => {

            let data = response.data
              .filter(user => user.active && user.role.includes("member"))
              .map(user => user.email);

            this.emails = this.emails.concat(data);

            this.done++;

            if (this.done == this.maxDone)
              onComplete();
          }, (response) => {
            // called asynchronously if an error occurs
            // or server returns response with an error status.
            this.done++;

            if (this.done == this.maxDone)
              onComplete();
          });
        });

      default:
        break;
    }
  }

}

export default angular.module('directives.navbar', [])
  .component('navbar', {
    template: require('./navbar.html'),
    controller: NavbarComponent
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/navbar/navbar.component.js